import { getAllUserInformationOnIssues, type UserInformation } from './users.tsx';
import { createIssueHook } from './utils.tsx';

export const useAllUserInformationOnIssues = createIssueHook<UserInformation>(
	getAllUserInformationOnIssues,
);
